<ul class="nav nav-tabs" id="vehicleTabs" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="find-tab" data-toggle="tab" data-target="#vehicle-find" type="button" role="tab" aria-controls="home" aria-selected="true"><span class="mdi mdi-magnify"></span> Find</button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="add-tab" data-toggle="tab" data-target="#vehicle-add" type="button" role="tab" aria-controls="profile" aria-selected="false"><span class="uil-plus"></span> New Vehicle</button>
    </li>
</ul>

<div class="tab-content" id="vehicleTabContent">

    <div class="tab-pane fade show active" id="vehicle-find" role="tabpanel" aria-labelledby="find-tab">
        <div class="card">
            <div class="card-header">
                <form [formGroup]="form">
                    <div class="input-group">
                        <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" placeholder="{{ words[language]['typeToFilterOut'] }} {{ words[language]['vehicles'] }}">
                        <div class="input-group-append">
                            <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-body p-0 pb-1">

                <div id="listing" class="col-md-12" (scroll)="scrolled($event)">
                    @if (vehicles) {
                    <table class="table table-sm table-hover table-striped" id="vehicleTable">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th (click)="sort('name')" class="sorted" scope="col">{{ words[language]['Stock Number'] }}</th>
                                <th scope="col">{{ words[language][ 'Status' ] }}</th>
                                <th scope="col">{{ words[language]['Year'] }} {{ words[language]['Make'] }} {{ words[language]['Model'] }}</th>
                                @if (allowAddVehicle) {
                                    <th scope="col">{{ words[language][ 'Trim' ] }}</th>
                                }
                                <th scope="col">{{ words[language][ 'VIN Number' ] }}</th>
                                @if (allowAddVehicle) {
                                    <th scope="col" class="text-right">{{ words[language][ 'Mileage' ] }}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of vehicles; track item) {
                            <tr class="clickable text-dark" (click)="vehicleSelected(item.id, item)">
                                <td>
                                    @if (item.url) {
                                        <img [src]="item.url" [alt]="item.model" />
                                    }
                                </td>
                                <th scope="row">{{item.stock}}</th>
                                <th scope="row" [class.text-warning]="item.status.toLowerCase() === 'quoted'">{{item.status}}</th>
                                <td>
                                    <div class="flex-start">
                                        <span class="pallette" [style.backgroundColor]="item.exteriorColor ? item.exteriorColor.toLowerCase() : null">&nbsp;</span>
                                        <span class="pallette" [style.backgroundColor]="item.interiorColor ? item.interiorColor.toLowerCase() : null">&nbsp;</span>
                                        <span>{{item.year}} {{item.make}} {{item.model}}</span>
                                    </div>
                                </td>
                                @if (allowAddVehicle) {
                                    <th scope="row">{{item.trimLevel}}</th>
                                }
                                <td>{{item.vin}}</td>
                                @if (allowAddVehicle) {
                                    <td class="text-right">{{item.miles | number:'1.0-0'}}</td>
                                }
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
                <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                    {{words[language]['displayed']}}</p>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="vehicle-add" role="tabpanel" aria-labelledby="add-tab">
        <div class="card">
            <div class="card-header text-right">
                <button class="btn btn-sm btn-primary" (click)="saveVehicle($event)" [disabled]="!canSave">Save and Use</button>
            </div>
            <div class="card-body">
                <inventory-quick-add [saved]="vehicleSavedEvent" (validity)="vehicleValidity($event)" (created)="vehicleSelected($event.id, $event)"></inventory-quick-add>
            </div>
            <div class="card-footer text-right">
                <button class="btn btn-sm btn-primary" (click)="saveVehicle($event)" [disabled]="!canSave">Save and Use</button>
            </div>
        </div>
    </div>

</div>